<template>
  <div class="bet-confirmation">
    <div class="bet-confirmation__header">
      <div class="bet-confirmation__header__title">
        BET CONFIRMATION
      </div>
      <div class="bet-confirmation__header__clear">
        <img
            @click="$parent.$emit('close')"
            class="bet-confirmation__header__close"
            src="@/assets/images/ticket/remove.png"
        />
      </div>
    </div>
    <div class="bet-confirmation__content">
      <div class="bet-confirmation__content__fields">
        <div class="item-common-bet-confirm">
        </div>
<!--        <div class="bet-confirmation__content__field__ticket">-->
<!--          Ticket#/ Error-->
<!--        </div>-->
        <div class="item-common-bet-confirm">
          Stake
        </div>
        <div class="item-common-bet-confirm">
          Pay
        </div>
        <div class="item-common-bet-confirm">
          Draw
        </div>
      </div>
      <div v-if="listBetslips.length > 0">
        <div
            v-for="(item, index) in listBetslips"
            :key="index"
            class="bet-confirmation__content__item"
            @click="$parent.$emit('click-item', index+1)"
        >
          <div v-if="item.numbers[0] && item.numbers[0].length > 0 || item.numbers[1] && item.numbers[1].length > 0" class="bet-confirmation__item__numbers__content item-common-bet-confirm">
            <div
                v-for="(number, i) in item.numbers[0]"
                :key="i"
                class="bet-confirmation__item__numbers__content__number"
            >
              <a>{{ number }}</a>
            </div>
            <div
                v-for="(number, i) in item.numbers[1]"
                :key="i"
                :class="{bonus: number.isBonus || number.type === 'bonus' || number.type === 'power'}"
                class="bet-confirmation__item__numbers__content__number"
            >
              <a>{{ number }}</a>
            </div>
          </div>
          <div v-if="item.numbers.length === 0" class="bet-confirmation__item__numbers__content item-common-bet-confirm">
            <b>{{ item.text }} </b>
          </div>
<!--          <div class="bet-confirmation__content__item__ticket item-common-bet-confirm">-->
<!--            {{ item.slug }}-->
<!--          </div>-->
          <div class="bet-confirmation__content__item__stake item-common-bet-confirm">{{ currencySymbol }}{{ $filters.formatThousandNumber(item.stake) }}</div>
          <div class="bet-confirmation__content__item__pay item-common-bet-confirm">{{ currencySymbol }}{{ $filters.formatThousandNumber(item.paid || 0) }}</div>
          <div class="bet-confirmation__content__item__draw item-common-bet-confirm">{{ item.drawName}}</div>
        </div>
      </div>
      <div v-if="listBetslips.length === 0" class="bet-confirmation__no-data">
        No data, please continue betting!
      </div>
    </div>
    <div class="bet-confirmation__buttons">
      <div
          @click="$parent.$emit('close')"
          class="bet-confirmation__buttons__continue"
      >
        CONTINUE BETTING
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      listBetslips: [],
      currencySymbol: process.env.VUE_APP_CURRENCY_SYMBOL,
    }
  },
  created() {
    let yourBetslipStorage = localStorage.getItem('yourBetslip')
    if(yourBetslipStorage) {
      yourBetslipStorage = JSON.parse(yourBetslipStorage)
      this.listBetslips = yourBetslipStorage;
    }
    this.$parent.$emit('removeBetslip')
    localStorage.removeItem('yourBetslip');
    localStorage.removeItem('draws');
    this.$store.dispatch('changeBadgeNumber', 0);
  },
  methods: {
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/ticket/betConfirmation.scss"/>
